<template>
  <tile class="opc-zsched">
    <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true">
      <template #head>
      <div class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <div class="opc-zm-base-card__head-right-content">
            <h2 class="opc-zm-base-card__name text-capitalize">
              {{ title }}
            </h2>
            <div class="opc-zm-base-card__view-detail-button">
              <zm-button
                data-testid="checkout-button-250"
                type="text"
                @click="handlePlanDetailsClick"
                v-if="isExpanded && showPlanDetail"
              >
                {{ $t('billing.plan_details') }}
              </zm-button>
            </div>
          </div>
          <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            {{ planCollapseText }}
          </div>
        </div>
      </div>
      </template>
      <div class="opc-zsched__trial-desc">
        <p class="opc-zsched__desc-text">
          <zm-icon><CheckmarkFill /></zm-icon>
          {{ $t('billing.scheduler.free_trial_descriptions.duration', [trialDays]) }}
        </p>
        <p class="opc-zsched__desc-text">
          <zm-icon><CheckmarkFill /></zm-icon>
          {{ $t('billing.scheduler.free_trial_descriptions.sharelink') }}
        </p>
        <p class="opc-zsched__desc-text">
          <zm-icon><CheckmarkFill /></zm-icon>
          {{ $t('billing.scheduler.free_trial_descriptions.customizable') }}
        </p>
        <p class="opc-zsched__desc-text">
          <zm-icon><CheckmarkFill /></zm-icon>
          {{ $t('billing.scheduler.free_trial_descriptions.cancel') }}
        </p>
      </div>
      <div class="opc-zsched__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form" @submit.prevent>
          <zm-form-item :label="$t('billing.select_billing_cycle')" id="opc-zsched__billing-cycle">
            <billed-billing-cycle-radio
              v-model="form.billingCycle"
              :billingCycleList="billingCycleList"
              :is-trial="true"
              @change="updateBillingCycle"
            />
          </zm-form-item>
        </zm-form>
      </div>
      <div data-testid="checkout-div-252" class="opc-zsched__free-trial-footer" v-html="$t('billing.scheduler.free_trial_footer', [paidPurchaseLink])" @click="clickBuyNow"/>
      <basic-related-tip v-if="isNetNew" />
      <div class="opc-zm-base-card__main__footer" v-if="couldBeRemovedAsAddonCard">
        <zm-button data-testid="checkout-button-253" type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
      </div>
    </foldable>
  </tile>
</template>
<script>
import { CheckmarkFill } from '@zoom/icons-vue';
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import baseFormMixin from '@/plans/ZOOM_SCHEDULER/mx/base';
import formMixin from '@/plans/ZOOM_SCHEDULER/mx/index';
import saveMixins from '../../ZOOM_MEETING/save-mixins';
import { BillingCycleEnum } from '@/common/constants';
import BasicRelatedTip from '@/plans/ZOOM_SCHEDULER/components/basic-related-tip.vue';
import { $context } from '@/global-install';
import { planTypes } from '@/common/constants'
import BilledBillingCycleRadio from "@/components/service/config-billing-cycle/billed-cycle/index.vue";
import { getFreeTrialPlanCollapseText } from '@/common/product';

export default {
  key: planTypes[planTypes.ZOOM_SCHEDULER],
  methods: {
    BillingCycleEnum() {
      return BillingCycleEnum;
    },
  },
  mixins: [baseFormMixin, formMixin, saveMixins],
  components: {
    BilledBillingCycleRadio,
    BasicRelatedTip,
    Foldable,
    Tile,
    CheckmarkFill,
  },
  computed: {
    isNetNew() {
      return $context.is.buyNow || $context.is.buyTrial || $context.is.basic2pro;
    },
    planCollapseText() {
      if (!this.formPlan) {
        return '';
      }
      return getFreeTrialPlanCollapseText({
        amount: this.formPlan.amount,
        billingCycle: this.form.billingCycle,
        quantity: this.form.selectedNumber,
        cycleValue: this.formPlan.cycleValue,
        unit: this.formPlan.unit,
      });
    },
  }
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-zsched {
  &__trial-desc {
    margin-left: 56px;
    @include media(mobile, tablet){
      margin: 8px 44px;
    }
  }
  &__desc-text {
    display: flex;
    align-items: center;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    margin: 4px 0;
    .zbo-icon {
      color: var(--zoom-color-fill-primary, #0D6BDE);
      margin-right: 6px;
    }
  }  
  &__free-trial-footer {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--zoom-color-text-neutral, #686F79);
    a {
      color: var(--zoom-color-text-primary, #0D6BDE);
    }
  }
  .opc-card-radio {
    margin-top: 8px;

    .opc-zsched__radio {
      width: 100%;
      .zbo-radio__wrap {
        width: 100%;
      }
    }
  }
  .opc-card-radio &__radio {
    .zbo-radio__label--inner {
      width: 100%;
      min-height: 90px;
      padding: 16px;
    }
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      margin: 0;
    }
    &-price {
      font-style: normal;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      word-break: break-word;
      &-amount {
        font-weight: 590;
        font-size: 24px;
        line-height: 28px;
      }
      &-unit {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
}
</style>
